/* Timeline */
/* -------------------------------------------- */
function initTimeline() {
    if(!$('.section-timeline')[0]) { return }

    /* Variables */
    /* -------------------- */
    var $timeline = document.querySelector("#timeline");
    var timelineStart, timelineStop, date;
    var timelineSticky = false;
    var timelineBuilt = false;
    var timelineCount = $('.timeline-part').length;
    var timelineImage = $('.timeline-part img');
    var timelinePartWidth = 50;
    var timelineWidth = 0;
    var dateCount = $('.date-container').length;
    var dateWidth = dateCount * 75;
    var bonusArea = 0;
    var windowY = 0;
    var dates = new Array();
    /* -------------------- */

    window.addEventListener('load', function() {
        $(window).on('resize', function() {
            setTimeout(function(){
                if(!realResize || !$timeline) return false;
                checkSize();
                timelineResponsive();
            }, 100);

        }).trigger('resize');
    });

    function timelineResponsive() {
        $timeline.classList.add("restore");
        $timeline.classList.remove('position-fixed');

        timelineWidth = convertVWtoPX((timelinePartWidth * timelineCount)+bonusArea);

        timelineStart = $timeline.offsetTop;
        timelineStop = timelineStart + timelineWidth;

        $('#timeline').css('width', (timelineWidth) + 'px');
        $('#timelineScroll').css('height', (timelineWidth) + 'px');
        timelineSticky = false;
        timelineBuilt = true;
        $timeline.classList.remove('hidden');

        timeline();
    };

    function timeline() {
        if (windowY > timelineStart) {
            if (!timelineSticky) {
                $timeline.classList.add("position-fixed");
                $timeline.classList.remove('restore');
                timelineSticky = true;
            }
            $timeline.style.transform = 'translate3D(-' + (windowY - timelineStart) +'px, 0px, 0)';
        }  else if (windowY < timelineStart && timelineSticky) {
            $timeline.classList.remove("position-fixed");
            $timeline.classList.add('restore');
            timelineSticky = false;
        }
    }

    function convertVWtoPX(vw) {
        return document.documentElement.clientWidth * (vw / 100);
    }

    function checkSize() {
        if ($(window).width() < 992) {
            timelinePartWidth = 50;
            bonusArea = 200;
        } else {
            timelinePartWidth = 40;
            bonusArea = 0;
        }
    }

    function fadeIn() {
        var windowHeight = jQuery( window ).height();
        timelineImage.each(function(){
            var thisPos = $(this).offset().left;
            var topOfWindow = $(window).scrollTop();
            if ((windowY - timelineStart) > thisPos) {
                $(this).addClass('fade-in');
            }
        })
    }

    checkSize();
    timelineResponsive();
    fadeIn();

    $(window).on('scroll', function() {
        windowY = $(window).scrollTop();
        timeline();
        fadeIn();
    });
};

initTimeline();
